module.exports = __webpack_public_path__ + "img/logo-iconic-landscape.89fdb62f.png";